import { render, staticRenderFns } from "./ServiceSidebar.vue?vue&type=template&id=2f798cf1&"
import script from "./ServiceSidebar.vue?vue&type=script&lang=js&"
export * from "./ServiceSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f798cf1')) {
      api.createRecord('2f798cf1', component.options)
    } else {
      api.reload('2f798cf1', component.options)
    }
    module.hot.accept("./ServiceSidebar.vue?vue&type=template&id=2f798cf1&", function () {
      api.rerender('2f798cf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/General/Sidebar/ServiceSidebar.vue"
export default component.exports